import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';

@Component({ name: 'DebugModel' })
export default class DebugModel extends Vue {
  @Prop()
  readonly model!: object;
}
